/**
 * Returns a copy of given array.
 *
 * @param {array} array
 */
export function arrayCopy (array) {
  return array.slice()
}

/**
 * Returns the first element of given array.
 *
 * @param {array} array
 */
export function arrayFirst (array) {
  if (Array.isArray(array)) {
    return array[0]
  }
}

export default {
  arrayCopy,
  arrayFirst,
}



// WEBPACK FOOTER //
// ./src/server/helpers/array.js